import { useEffect, useRef, useState } from "react";

const TICK_INTERVAL_MS = 1000;

export const useCountdown = (seconds: number) => {
  const [secondsLeft, setSecondsLeft] = useState(seconds);
  const intervalId = useRef(0);

  useEffect(() => () => clearInterval(intervalId.current), []);

  const start = () => {
    clearInterval(intervalId.current);
    setSecondsLeft(seconds);

    const expireAt = Date.now() + seconds * 1000;

    intervalId.current = window.setInterval(() => {
      const remainingSeconds = Math.max(0, Math.ceil((expireAt - Date.now()) / 1000));

      setSecondsLeft(remainingSeconds);
      if (remainingSeconds === 0) clearInterval(intervalId.current);
    }, TICK_INTERVAL_MS);
  };

  return { secondsLeft, isExpired: secondsLeft === 0, start };
};
